export default __webpack_public_path__ + "static/media/playAudio3.59f51b38.svg";